// API Configuration
// Centralized configuration for backend API endpoints

// Get the API base URL from environment variable or default to localhost
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3000";

// Export the base URL for socket.io connections (same as API)
export const SOCKET_ENDPOINT = API_BASE_URL;

// Helper function to construct full API URLs
export const getApiUrl = (path) => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith("/") ? path.substring(1) : path;
  return `${API_BASE_URL}/${cleanPath}`;
};

// Export default for convenience
export default {
  API_BASE_URL,
  SOCKET_ENDPOINT,
  getApiUrl,
};
